import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    QueryDropdown,
    DateRangeQueryPicker
} from "core/components";
import { ApplicationListLayout, Content } from "core/layouts";

function FacilityHistoryListTemplate({ facilityHistoryListViewStore }) {
    
    const { tableStore, routes, queryUtility, authorization, facilityStore, historyEventTypeStore, dateRangePickerStore } = facilityHistoryListViewStore;

    return (
        <ApplicationListLayout
            store={facilityHistoryListViewStore}
            authorization={authorization}
        >
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility}>
                        <div className="form__group col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility"/>
                        </div>
                        <div className="form__group col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3">
                            <QueryDropdown queryUtility={queryUtility} store={historyEventTypeStore} propertyName="historyEventTypeId" label="Change Type"/>
                        </div>
                        <div className="form__group col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3">
                            <DateRangeQueryPicker queryUtility={queryUtility} store={dateRangePickerStore} fromPropertyName="dateFrom" toPropertyName="dateTo" timeZone="UTC"/>
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table no-actions-cell">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
}

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_HISTORY.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

FacilityHistoryListTemplate.propTypes = {
    facilityHistoryListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityHistoryListTemplate);